import React from "react";

// Brown stat card. `label` may span two lines (e.g. "PARTICIPATION\nTIME").
export default function StatCard({ label, value, unit }) {
    return (
        <div className="bg-[#6e4e37] rounded-[10px] h-[183px] px-[36px] pt-[32px] text-white">
            <p className="text-[24px] leading-snug tracking-[0.72px] whitespace-pre-line">
                {label}
            </p>
            <p className="leading-none mt-[6px]">
                <span
                    className="text-[64px] tracking-[3.2px]"
                    style={{ fontFamily: "Koulen, sans-serif" }}
                >
                    {value}
                </span>
                <span className="text-[24px] ml-3">{unit}</span>
            </p>
        </div>
    );
}
